<app-admin-page-shell
  titleKey="app.admin.dashboard.title"
  subtitleKey="app.admin.dashboard.subtitle"
  [panelled]="false"
>
  <div class="office-dashboard">
    <div class="office-dashboard__stats">
      <app-admin-stat-card
        accent="success"
        labelKey="app.admin.dashboard.publishedCourses"
        [value]="publishedCourses()"
        [loading]="isLoading()"
      />
      <app-admin-stat-card
        accent="purple"
        labelKey="app.admin.dashboard.pipelineCourses"
        [value]="pipelineCourses()"
        [loading]="isLoading()"
      />
      <app-admin-stat-card
        accent="warning"
        labelKey="app.admin.dashboard.pendingFactVideos"
        [value]="pendingFactVideos()"
        [loading]="isLoading()"
      />
      <app-admin-stat-card
        accent="primary"
        labelKey="app.admin.dashboard.enabledFlags"
        [value]="enabledFeatureFlags()"
        [loading]="isLoading()"
      />
    </div>

    <div class="office-dashboard__grid">
      <section class="office-dashboard__panel">
        <h2 class="office-dashboard__section-title">
          {{ 'app.admin.dashboard.systemStatus' | translate }}
        </h2>
        <ul class="office-dashboard__status-list">
          <li>
            <span>{{ 'app.admin.dashboard.identityLayer' | translate }}</span>
            <strong>{{ identityLayerLabel() | translate }}</strong>
          </li>
          <li>
            <span>{{ 'app.admin.dashboard.kycProvider' | translate }}</span>
            <strong>{{ identityKycProvider() }}</strong>
          </li>
          <li>
            <span>{{ 'app.admin.dashboard.legacyGraceDays' | translate }}</span>
            <strong>{{ identityGraceDays() }}</strong>
          </li>
          <li>
            <span>{{ 'app.admin.dashboard.patrolDiscord' | translate }}</span>
            <strong>{{ patrolDiscordLabel() }}</strong>
          </li>
          <li>
            <span>{{ 'app.admin.dashboard.patrolRoblox' | translate }}</span>
            <strong>{{ patrolRobloxLabel() }}</strong>
          </li>
        </ul>
      </section>

      <section class="office-dashboard__panel">
        <h2 class="office-dashboard__section-title">
          {{ 'app.admin.dashboard.quickActions' | translate }}
        </h2>
        <div class="office-dashboard__actions">
          <a [routerLink]="['../content']" class="office-dashboard__action">
            {{ 'app.admin.dashboard.openContent' | translate }}
          </a>
          <a [routerLink]="['../daily-facts']" class="office-dashboard__action">
            {{ 'app.admin.dashboard.generateDailyFacts' | translate }}
          </a>
          <a [routerLink]="['../patrol']" class="office-dashboard__action">
            {{ 'app.admin.dashboard.openPatrol' | translate }}
          </a>
          <a [routerLink]="['../identity']" class="office-dashboard__action">
            {{ 'app.admin.dashboard.openIdentity' | translate }}
          </a>
          <a [routerLink]="['../settings']" class="office-dashboard__action">
            {{ 'app.admin.dashboard.openSettings' | translate }}
          </a>
        </div>
      </section>
    </div>
  </div>
</app-admin-page-shell>
